import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useExportReport } from 'src/hooks/api'
import { useModal } from '@gluedigital/modal'
import { useHistory, Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { logout } from 'src/store/actions/user'
import { Role } from 'src/types'

const ClientSettings = () => {
  const modal = useModal()
  const fetchExport = useExportReport()

  return (
    <>
      <li>
        <div onClick={() => modal.show('upload-csv-modal')} className="text">
          <span className="icon icon-csv" />
          <span><FormattedMessage id="user-settings.csv" /></span>
        </div>
      </li>
      <li>
        <div onClick={fetchExport} className="text">
          <span className="icon icon-download" />
          <span><FormattedMessage id="user-settings.export" /></span>
        </div>
      </li>
      <li>
        <Link to="/assets/hidden">
          <span className="icon icon-eye" />
          <span><FormattedMessage id="user-setting.hidden-assets" /></span>
        </Link>
      </li>
    </>
  )
}

interface SettingsProps {
  role: Role
}

const Settings = ({ role }: SettingsProps) => {

  const dispatch = useDispatch()
  const history = useHistory()

  const handleLogout = e => {
    e.preventDefault()
    dispatch(logout())
    history.push('/')
  }

  return (
    <>
      <li>
        <Link to="/profile">
          <span className="icon icon-pencil" />
          <span><FormattedMessage id="user-settings.edit" /></span>
        </Link>
      </li>
      {role === 'CLIENT' ? <ClientSettings /> : null}
      <li>
        <Link to="/user/new">
          <span className="icon icon-add" />
          <span><FormattedMessage id="user-settings.new-user" /></span>
        </Link>
      </li>
      <li>
        <a href="/securitas-ada-admin.pdf" download="manual-ada-admin">
          <span className="icon icon-info" />
          <span><FormattedMessage id="user-settings.manual" /></span>
        </a>
      </li>
      <li onClick={handleLogout}>
        <div className="text">
          <span className="icon icon-logout" />
          <span><FormattedMessage id="logout" /></span>
        </div>
      </li>
    </>
  )
}

export default Settings
